export enum PropertyWindowSaveState {
    Unchanged,
    SaveSucceeded,
    SaveFailed,
    Cancelled,
    SaveValidationFailed
}